import { combineReducers } from 'redux';
import SamsungOrderInvoice from 'src/pages/SamsungOrderInvoiceView/SamsungOrderInvoiceView';
import types from './types';
import SamsungOrderInvoiceModel from 'src/model/samsungOrderInvoice.model';
import INITIAL_STATE, { IInitialState } from 'src/store/initialState';

const samsungOrderInvoices = (
  state: IInitialState['samsungOrderInvoiceView']['samsungOrderInvoices'] = INITIAL_STATE
    .samsungOrderInvoiceView.samsungOrderInvoices || [],
  {
    type,
    payload
  }: {
    type: string;
    payload: SamsungOrderInvoiceModel[];
  }
) => {
  switch (type) {
    case types.PORTAL_DATA:
      return payload;
    default:
      return state;
  }
};

const samsungOrderResultData = (
  state: IInitialState['samsungOrderInvoiceView']['samsungOrderResultData'] = INITIAL_STATE
    .samsungOrderInvoiceView.samsungOrderResultData || [],
  {
    type,
    payload
  }: {
    type: string;
    payload: any[][];
  }
) => {
  switch (type) {
    case types.RESULT_DATA:
      return payload;
    default:
      return state;
  }
};

const pageInformation = (
  state: IInitialState['samsungOrderInvoiceView']['pageInformation'] = INITIAL_STATE
    .samsungOrderInvoiceView.pageInformation || {
    pageNumber: 0,
    pageSize: 20,
    totalElements: 20,
    totalPages: 1
  },
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_PAGE_INFO:
      return payload;
    default:
      return state;
  }
};

const samsungSearchForm = (
  state: IInitialState['samsungOrderInvoiceView']['samsungSearchForm'] = INITIAL_STATE
    .samsungOrderInvoiceView.samsungSearchForm || {
    action: 'SEARCH',
    productCode: '',
    palletRegNumber: '',
    customerCode: '',
    orderNumber: '',
    orderReference: '',
    ticket: '',
    dateFrom: null,
    dateTo: null
  },
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_SAMSUNG_SEARCH_FORM:
      return payload;
    default:
      return state;
  }
};

export default combineReducers({
  samsungSearchForm,
  samsungOrderInvoices,
  samsungOrderResultData,
  pageInformation
});
